import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { AvatarAi } from "./AvatarAi";

type TAiMessageProps = {
  state?: "default" | "error";
  avatarVariant?: "filled" | "outlined";
  children: ReactNode;
  className?: string;
};

export function AiMessage({ state = "default", avatarVariant = "filled", children, className }: TAiMessageProps) {
  return (
    <div className={cn("flex w-full min-w-0 items-start gap-3 bg-innoveraGeneral-white py-3", className)}>
      <AvatarAi state={state} variant={avatarVariant} />
      <div className="flex min-w-0 flex-1 flex-col items-start justify-center gap-2.5 py-1">{children}</div>
    </div>
  );
}
